import { Component } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, combineLatest } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { CustomOhgarCategoryBlocksComponentData } from './custom-ohar-category-blocks.model';

@Component({
  selector: 'app-custom-ohgar-category-blocks',
  templateUrl: './custom-ohgar-category-blocks.component.html',
  styleUrls: ['./custom-ohgar-category-blocks.component.scss'],
  standalone: false
})
export class CustomOhgarCategoryBlocksComponent {
  constructor(
    protected componentData: CmsComponentData<CustomOhgarCategoryBlocksComponentData>,
    private cmsService: CmsService
  ) { }

  data$ = this.componentData.data$.pipe(map(component => component));
  items$: Observable<any[]> = this.componentData.data$.pipe(
    switchMap(data =>
      combineLatest(
        data.items.trim().split(' ').map((codes: any) => this.cmsService.getComponentData(codes).pipe(
          map(tab => tab)
        )))
    ));
}
